/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Issue_Duplicate_ChangeInputs */

const en_po_issue_duplicate_change = /** @type {(inputs: Po_Issue_Duplicate_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is named more than once`)
};

/**
* | output |
* | --- |
* | "is named more than once" |
*
* @param {Po_Issue_Duplicate_ChangeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_issue_duplicate_change = /** @type {((inputs?: Po_Issue_Duplicate_ChangeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Issue_Duplicate_ChangeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_issue_duplicate_change(inputs)
});